import { Card } from "@/core/components/ui/card";
import { Stack } from "@/core/components/ui/stack";
import { cn } from "@/core/utils/utils";

export const MainCard = ({
  className,
  ...otherProps
}: React.ComponentProps<typeof Card>) => (
  <Card
    className={cn(
      "h-[calc(100vh-180px)] w-[calc(100vw-281px)] min-w-[800px] overflow-hidden rounded-2xl",
      className,
    )}
    {...otherProps}
  />
);

export const MainStack = ({
  className,
  showOverflow = false,
  ...otherProps
}: React.ComponentProps<typeof Stack> & { showOverflow?: boolean }) => (
  <Stack
    fullWidth
    className={cn("h-full pl-6", !showOverflow && "overflow-hidden", className)}
    {...otherProps}
  />
);

export const HeaderStack = ({
  ...otherProps
}: React.ComponentProps<typeof Stack>) => (
  <Stack
    direction="row"
    justify="between"
    align="center"
    className="h-[56px] flex-grow-0 py-2 pr-6"
    fullWidth
    {...otherProps}
  />
);
